import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'

class AboutOrganiserIndiaITMESociety extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        this.loadscript()
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }
    render() {
        const { } = this.state;
        return (
            <>
                <StaticHeader />
                <>
                    <div className="website">
                        <section className="banner page-banner position-relative pb-0">
                            <div className="overlay"></div>
                            <div className="container">
                                <div className="page-title text-center position-relative py-4 mt-4">
                                    <h2 className="text-white text-uppercase mt-4"><img
                            src="static/images/org-logo-b.png"
                            alt="group-image"
                            className="org-logo-b pt-2"
                        />India ITME Society</h2>
                                </div>
                            </div>
                        </section>
                        <img
                            src="static/images/page-logo.png" 
                            alt="group-image"
                            className="org-logo"
                        />
                        <section className="conference">

                            <div className="container">
                                <div className="conference-inner text-center">
                                    <div className="row gx-lg-5 align-items-center">
                                        <div className="col-lg-12 order-1 order-lg-2">
                                            <div className="event-benifit-list-right text-lg-start">
                                                <div className="overview-info text-justify">

                                                    <p className="mb-2">India International Textile Machinery Exhibitions Society
                                                        (India ITME Society), a 45 year old  non profit apex industry body,
                                                        established in 1980, to support and serve the Textile Engineering Industry
                                                        through Exhibitions & Events. </p>

                                                    <p>India ITME Society was conceived with a Vision to play a pivotal role in strengthening the
                                                        Indian Textile Engineering Industry by facilitating exchange of knowledge, technology
                                                        transfer & foreign investment in the sector and to be the apex
                                                        exhibition body in India for the textile machinery, accessories
                                                        and component industry. </p>

                                                    <p>The organisation and its team works relentlessly
                                                        towards its Mission to aid, stimulate, promote, encourage & support trade and commerce with a focus on
                                                        Textile Engineering and allied industries, through exhibitions and conferences, thus propagating the
                                                        cause of Textile Engineering
                                                        Industry at National and International levels.</p>

                                                    <p>With the motto of empowering Textiles through Trade & Technology,
                                                        India ITME Society relentlessly spots the right opportunities that
                                                        will contribute to the greater good. Over the years India ITME Society has
                                                        evolved into the next level, metamorphosing from an Indian organiser to a
                                                        global phenomenon embracing internationalism exploring & connecting
                                                        emerging economies to Indian Textile & Engineering Industry. </p>

                                                    <p>The society has left no stones unturned in establishing
                                                        itself as one of India's most successful exhibition
                                                        organizers with its principles based on trust, consistency & collaboration. </p>

                                                    <ul>
                                                        <li><p>&nbsp; &nbsp; &nbsp; &nbsp; • For more information visit : <a className="text-primary" href="https://corporate.india-itme.com/">https://corporate.india-itme.com/</a> </p></li>
                                                        <li><p>&nbsp; &nbsp; &nbsp; &nbsp; • To view the brochure click  : <a className="text-primary" href="https://corporate.india-itme.com/Corporate-Flipbook/"> India ITME Society Corporate Brochure (india-itme.com)</a> </p></li>
                                                        <li><p>&nbsp; &nbsp; &nbsp; &nbsp; • To view the video click  <a className="text-primary" href="https://www.youtube.com/watch?v=krrTau-uvCw">https://www.youtube.com/watch?v=krrTau-uvCw</a> </p></li>
                                                    </ul>

                                                   <a target="_blnk" href="https://www.youtube.com/watch?v=krrTau-uvCw"> <img
                                                        src="static/images/ab-vid.png"
                                                        alt="group-image"
                                                        className="my-4"
                                                    /></a>

                                                    <p className="pt-3">India ITME Society today organizes exhibitions every year,
                                                        addressing different requirements of the industry segment under its banner. </p>

                                                    <p className="mb-2"> &nbsp; &nbsp; &nbsp; &nbsp; 1. India International Textile Machinery Exhibition <b>(INDIA ITME)</b> - (Flagship event
                                                        since 1980 completing 44 years)</p>

                                                    <p className="mb-2"> &nbsp; &nbsp; &nbsp; &nbsp; 2.	Global Textile Technology & engineering show <b>(GTTES) </b>-
                                                        (Focused on SME sector and regional hubs)</p>

                                                    <p className="mb-2"> &nbsp; &nbsp; &nbsp; &nbsp; 3.	International Technology, Machinery & Engineering Exhibition
                                                        <b>(ITME AFRICA & MIDDLE EAST)</b> (overseas edition).</p>

                                                    <p className="mb-2"> &nbsp; &nbsp; &nbsp; &nbsp;  4.	India ITME Virtual Buyer Seller Meet <b>(ITME Virtual BSM)</b></p>

                                                    <p className="pt-3">India ITME Society is a trend setter for out of box ideas in serving the industry members, not limited
                                                        to India, but in Africa, Middle East and other frontiers as well. India ITME
                                                        Society’s relentless passion to innovate & excel forward towards new
                                                        goals have resulted in a plethora of upcoming projects such as </p>

                                                    <p className="mb-2">&nbsp; &nbsp; &nbsp; &nbsp; 1.	<b>ITME Trade Services</b> which shall offer </p>
                                                    <ul>
                                                        <li className="mb-2">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; a.	Trade Missions : Inbound & Outbound</li>
                                                        <li className="mb-2">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; b.	Trade Enquiry : For Business Opportunities</li>
                                                        <li className="mb-2">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; c.	Trade Information : Knowledge Sessions & Webinars</li>
                                                        <li className="mb-2">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; d.	India Pavilion at International Exhibition </li>
                                                        <li className="mb-2">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; e.	Project Consultancy</li>
                                                        <li className="mb-2">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; For more information visit : <a className="text-primary" href="http://www.tradedesk.india-itme.com/">www.tradedesk.india-itme.com</a></li>
                                                    </ul>

                                                    <p>&nbsp; &nbsp; &nbsp; &nbsp; 2. <b>India ITME Awards</b> one & only award exclusive for Textile Technology & Engineering Sector.
                                                        For more information visit : <a className="text-primary" href="www.awards.india-itme.com">www.awards.india-itme.com</a>
                                                    </p>

                                                    <p>Humility of action, integrity of purpose and transparency of conduct
                                                        are the key traits driving the Society’s growth and its journey
                                                        forward. <b>“India ITME Society – Empowering Textiles through Trade & Technology.” </b></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </>

                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, {})(AboutOrganiserIndiaITMESociety)
);
